

export class AppSettings { 
    private static _baseUrl = "https://wyens.co"
    private static _endpoint = "https://api.wyens.co"
    private static _testendpoint = "https://api.wyens.co"
    private static _sitename = "Wyens Co"
    private static _sitedescription = ""
    private static _devMode = true
    
    public static get endpoint(){
        return this._devMode ? this._testendpoint : this._endpoint
    }

    public static get sitename() {
        return this._sitename
    }
    
    public static get sitedescription() {
        return this._sitedescription
    }

    public static get devMode(){
        return this._devMode;
    }

    public static get baseUrl(){
        return this._baseUrl
    }
}